<!-- The one form that schedules an activity (E4 RF-01, RF-04). Hyper form markup. -->
<div [formGroup]="form">
  <div class="row">
    <div class="col-md-5 mb-3">
      <label class="form-label" [attr.for]="idPrefix + 'Type'">{{ 'task.nextForm.type' | translate }}</label>
      <select [id]="idPrefix + 'Type'" class="form-select" formControlName="type">
        @for (type of types; track type.value) {
          <option [value]="type.value">{{ type.label | translate }}</option>
        }
      </select>
      @if (showTypeError) {
        <span class="help-block text-danger"><small>{{ 'task.nextForm.typeRequired' | translate }}</small></span>
      }
    </div>
    <div class="col-md-7 mb-3">
      <label class="form-label" [attr.for]="idPrefix + 'Name'">{{ 'task.nextForm.title' | translate }}</label>
      <input
        [id]="idPrefix + 'Name'"
        type="text"
        class="form-control"
        formControlName="name"
        maxlength="100"
        [placeholder]="'task.nextForm.titlePlaceholder' | translate"
      />
      <span class="help-block"><small class="text-muted">{{ 'task.nextForm.titleHelp' | translate }}</small></span>
    </div>
  </div>

  <div class="mb-3">
    <app-schedule-moment-field
      formControlName="moment"
      [allowUntimed]="allowUntimed"
      [idPrefix]="idPrefix + 'Moment'"
    />
  </div>

  @if (showNotes) {
    <div class="mb-3">
      <label class="form-label" [attr.for]="idPrefix + 'Description'">{{ 'task.nextForm.notes' | translate }}</label>
      <textarea
        [id]="idPrefix + 'Description'"
        class="form-control"
        rows="2"
        formControlName="description"
        [placeholder]="'task.nextForm.notesPlaceholder' | translate"
      ></textarea>
    </div>
  }
</div>
